import { render } from "./homeIndex.vue?vue&type=template&id=7632458a"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__